import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {event} from '../ga'

const withGAOnClick = WrappedComponent =>
  class extends Component {
    static propTypes = {
      gaCategory: PropTypes.string,
      gaAction: PropTypes.string,
      gaLabel: PropTypes.string,
      onClick: PropTypes.func
    }

    static defaultProps = {onClick: () => {}}

    static displayName = `${WrappedComponent.displayName}WithGAOnClick`

    onClick = (...args) => {
      const {onClick, gaCategory, gaAction, gaLabel} = this.props

      if (gaCategory && gaAction) {
        event({category: gaCategory, action: gaAction, label: gaLabel})
      }

      onClick(...args)
    }

    render() {
      const {onClick, gaCategory, gaAction, gaLabel, ...props} = this.props

      return <WrappedComponent onClick={this.onClick} {...props}/>
    }
  }

export default withGAOnClick
